
<div *ngIf="isAttributionUnique()">
<app-type-attribution-marche-lot [uid]="getUid()" [parentForm]="parentForm"
    [disabled]="disabled" [attribue]="attribue" [errorMessagePersonneMoral]="{'required' : 'ctr_437'}"
    [type]="getType()">
</app-type-attribution-marche-lot>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
</div>
<span *ngIf="!isAttribue()">{{ step4.getspan17 | translate }}</span>
<span *ngIf="isAttribue() && !isAttributionUnique()">{{ step4.getspan18 | translate }}</span>
